export default {
  placeholder: 'Wybierz statusy zadań',
};
